// One coordinate space for camera mode. The mirrored webcam video is drawn full-screen with a
// cover-fit transform, and hand landmarks are mapped through the SAME transform — so the
// fingertip pixel in the rendered video and the on-screen cursor are the same point everywhere,
// by construction. No EDGE margins, no amplified central-region mapping (players use bigger,
// physical arm movements to reach the screen — the Kinect experience, intended).

export interface CoverRect {
  dw: number;
  dh: number;
  ox: number;
  oy: number;
}

// The rect the video is drawn into: cover-fit (fills the screen, cropping the overflow).
export function videoCoverRect(W: number, H: number, vw: number, vh: number): CoverRect {
  const s = Math.max(W / vw, H / vh);
  const dw = vw * s;
  const dh = vh * s;
  return { dw, dh, ox: (W - dw) / 2, oy: (H - dh) / 2 };
}

// Map a MediaPipe normalized landmark (raw, unmirrored frame coords in 0..1) to the screen pixel
// where it appears in the drawn video. X is mirrored to match the mirrored video draw; Y is not.
// Not clamped: if the finger is in the cropped-out region it maps off-screen, exactly like the
// finger is off the visible video.
export function landmarkToScreen(nx: number, ny: number, W: number, H: number, vw: number, vh: number): { x: number; y: number } {
  const { dw, dh, ox, oy } = videoCoverRect(W, H, vw, vh);
  return { x: W - (ox + nx * dw), y: oy + ny * dh };
}
